const showCodesPerPage = (width) => {

  if (width > 1900) {
    return 105
  }

  if (width > 1600) {
    return 90
  }

  if (width > 1400) {
    return 75
  }

  if (width > 1200) {
    return 60
  }

  if (width >= 1025) {
    return 45
  }

  if (width >= 940) {
    return 60
  }

  if (width >= 800) {
    return 45
  }

  if (width >= 769) {
    return 30
  }

  if (width >= 700 && width < 769) {
    return 75
  }

  if (width >= 560) {
    return 60
  }

  if (width >= 460) {
    return 45
  }

  if (width >= 375) {
    return 30
  }

  return 15
}

export default showCodesPerPage



// WEBPACK FOOTER //
// ./src/utils/showCodesPerPage.js